import React from "react";
import {useDrag} from "react-dnd";
import {ItemTypes} from "../team-page/itemTypes.js";
import {findObjectByKeyValue} from "../utils.js";
import {Link} from "react-router-dom";
import redCardIcon from '/src/assets/messages/card-red.png';
import { formatPlayerName } from '../../utils/playerName';


function PlayersList({players}) {

    const Players = players.map(function (item) {

        return (
            <div key={item.id} className="row pos-col">
                <div className="col">
                    {item.position}
                </div>
                <div className="col">
                    <span>{formatPlayerName(item.name)}</span>
                    {item.redCards > 0 && (
                        <img src={redCardIcon} alt="red card" title="Sent off" style={{ marginLeft: 6, height: '1em', verticalAlign: '-0.15em' }} />
                    )}
                </div>
                <div className="col">
                    {item.rating}
                </div>
                <div className="col">
                    {item.minutes}
                </div>
                <div className="col">
                    {item.saves}
                </div>
                <div className="col">
                    {item.keyTackles}
                </div>
                <div className="col">
                    {item.keyPasses}
                </div>
                <div className="col">
                    {item.assists}
                </div>
                <div className="col">
                    {item.shots}
                </div>
                <div className="col">
                    {item.goals}
                </div>
                <div className="col">
                    {item.points}
                </div>
                <div className="col">
                    {item.fitness}
                </div>
            </div>
        )
    });


    return (

        <div className="summary-table">

            <div className="row head-row">
                <div className="col">
                    Pos
                </div>
                <div className="col">
                    Name
                </div>
                <div className="col">
                    Rating
                </div>
                <div className="col">
                    Min
                </div>
                <div className="col">
                    Saves
                </div>
                <div className="col">
                    Key tackles
                </div>
                <div className="col">
                    Key passes
                </div>
                <div className="col">
                    Assists
                </div>
                <div className="col">
                    Shots
                </div>
                <div className="col">
                    Goals
                </div>
                <div className="col">
                    Points
                </div>
                <div className="col">
                    Fitness
                </div>
            </div>

            {Players}

        </div>
    )
}

export {PlayersList}
